<script>
import api from "@services/api";

export default {
  title: "teste",
  props: {
    chamadoId: {
      type: Number
    }
  },
  data() {
    return {
      historicoChamadoLista: [],
      item: {}
    };
  },
  computed: {},
  methods: {
    get() {
      api
        .get(`api/Chamado/GetListHistoricoChamado`, {
          params: {
            chamadoId: this.chamadoId
          }
        })
        .then(response => {
          var array = response.data["data"];
          this.historicoChamadoLista = array;
        });
    }
  },
  created() {
    this.get();
  }
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="p-2">
        <h4>Interações</h4>

        <div class="chamado-timeline ml-2">
          <ul class="timeline ">
            <div
              :class="
                item.cliente == -1 ? 'consultorInteracao' : 'ClienteInteracao'
              "
              v-for="(item, index) in this.historicoChamadoLista"
              v-bind:key="index"
            >
              <li>
                <span
                  :class="
                    item.cliente == -1
                      ? 'badge badge-success'
                      : 'badge badge-secondary'
                  "
                  >{{ item.usuario }}
                </span>

                <a
                  href="#"
                  class="ml-2"
                  :style="item.cliente != -1 ? 'color: #6b6d6c' : ''"
                >
                  {{ item.dataHora | formatField("date") }}</a
                >

                <p class="pre-formatted">
                  <b> {{ item.dataHora | formatField("moment-time") }} </b>
                  {{ item.descricao }}
                </p>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
